/**
 * @file
 * Carousel script.
 */

(function carouselScript($, Drupal, _) {
  'use strict';

  function setItemWidth($carousel) {
    let $carouselList = $carousel.find('.js-carousel-list');
    let $carouselItem = $carousel.find('.js-carousel-item');
    let curWidth = 0;

    $carouselList.removeAttr('style');
    $carouselItem.each(function () {
      curWidth += $(this).outerWidth(true);
    });
    return curWidth;
  }

  function slide($carousel, target) {
    let $carouselContainer = $carousel.find('#carouselContainer');
    let $carouselList = $carousel.find('#carouselList');
    let dir =
      $(target)
        .parent()
        .data('dir') || target;
    let curPos = parseInt($carouselList.css('left')) || 0;
    let moveTo = 0;
    let containerWidth = $carouselContainer.outerWidth();
    let listWidth = $carouselList.outerWidth();
    let before = curPos + containerWidth;
    let after = listWidth + (curPos - containerWidth);

    if (dir === 'next') {
      moveTo =
        after < containerWidth ? curPos - after : curPos - containerWidth;
    }
    else {
      moveTo = before >= 0 ? 0 : curPos + containerWidth;
    }
    return moveTo;
  }

  function magicLine($carousel, context) {
    let $carouselItem = $carousel.find('.js-carousel-item');
    let $magicLine = $('.magic-line', context);

    $magicLine
      .width($('[aria-selected="true"]', context).width())
      .css('left', $('[aria-selected="true"]', context).position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width());

    $carouselItem.click(function () {
      let $el = $(this).find(':first-child');
      let leftPos = $el.position().left;
      let newWidth = $el.width();
      $magicLine.stop().animate({
        left: leftPos,
        width: newWidth
      });
    });
  }

  function determineOverflow(content, container) {
    let containerMetrics = container.getBoundingClientRect();
    let containerMetricsRight = Math.floor(containerMetrics.right);
    let containerMetricsLeft = Math.floor(containerMetrics.left);
    let contentMetrics = content.getBoundingClientRect();
    let contentMetricsRight = Math.floor(contentMetrics.right);
    let contentMetricsLeft = Math.floor(contentMetrics.left);

    if (
      containerMetricsLeft > contentMetricsLeft &&
      containerMetricsRight < contentMetricsRight
    ) {
      return 'both';
    }
    else if (contentMetricsLeft < containerMetricsLeft) {
      return 'left';
    }
    else if (contentMetricsRight > containerMetricsRight) {
      return 'right';
    }
    else {
      return 'none';
    }
  }

  // Determine if an element is in the visible viewport.
  function isInViewport(el) {
    let rect = el.getBoundingClientRect();
    let html = document.documentElement;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  }

  function toggleArrowClasses($carousel, state) {
    $carousel
      .removeClass(
        'js-carousel__overflow--both js-carousel__overflow--left js-carousel__overflow--right js-carousel__overflow--none'
      )
      .addClass('js-carousel__overflow--' + state);
  }

  Drupal.behaviors.carousel = {
    attach: function carouselAttach(context) {
      let $carouselRoot = $('.js-carousel', context);
      let $nav = $('.site__header > .navigation', context);
      let isWalkthrough = $('.walkthrough-content', context).length;

      // Bounce if no carousel on page
      if (!$carouselRoot.length) {
        return;
      }

      $carouselRoot.each(function () {
        let $carousel = $(this);
        let $carouselList = $carousel.find('#carouselList');
        let $carouselContainer = $('#carouselContainer', context);
        let $carouselButton = $carousel.find('.js-carousel-button');
        // For calculations.
        let carouselList = document.getElementById('carouselList');
        let carouselContainer = document.getElementById('carouselContainer');

        let tabString = '';
        $('[id^="chapter-"]', context).each(function (i) {
          let $self = $(this);
          let headingText = $self.text();
          let headingId = $self.attr('id');
          let splitArr = headingId.split('-');
          let isSelected = i === 0;
          if (isWalkthrough) {
            tabString +=
              '<div class="carousel__item js-carousel-item"><a href="#' +
              headingId +
              '" class="tab__item" id="tab-' +
              splitArr[1] +
              '" aria-selected="' +
              isSelected +
              '"><div class="chapter-tab-index">' +
              (i + 1) +
              '</div><div class="chapter-tab-title">' +
              $.trim(headingText) +
              '</div></a></div>';
          }
          else {
            tabString +=
              '<div class="carousel__item js-carousel-item"><a href="#' +
              headingId +
              '" class="tab__item" id="tab-' +
              splitArr[1] +
              '" aria-selected="' +
              isSelected +
              '">' +
              headingText +
              '</a></div>';
          }
        });

        let $tabString = $(tabString);
        $carouselList.append($tabString);

        let $tabs = $('[id^="tab-"]', $tabString);
        $tabs.hammer().on('click tap press', function (e) {
          e.preventDefault();

          $tabs.attr('aria-selected', 'false').removeClass('tab__item--active');
          $(this).attr('aria-selected', 'true');

          let anchorId = $(this).attr('href');
          let $anchor = $(anchorId, context);
          if ($nav.length > 0) {
            let navHeight = $nav.outerHeight() || 0;
            if (navHeight) {
              let anchorOffset = $anchor.offset().top - $anchor.outerHeight();
              let scrollTopOffset = anchorOffset || 0;
              // Adjust for sticky nav.
              scrollTopOffset -= 3 * navHeight;
              // Buffer of 10px.
              scrollTopOffset -= 10;
              // Animate the scroll.
              if (scrollTopOffset > 0 && !isWalkthrough) {
                $('html, body', context).animate(
                  {
                    scrollTop: scrollTopOffset
                  },
                  {
                    duration: 600
                  }
                );
              }
              $anchor.focus();
            }
          }
        });

        let overflowState = 'right';
        toggleArrowClasses($carousel, overflowState);
        $carouselList.css('width', setItemWidth($carousel));
        magicLine($carousel, context);

        // Resize.
        $(window).on(
          'resize',
          _.throttle(function windowResize() {
            let overflowState = determineOverflow(
              carouselList,
              carouselContainer
            );
            toggleArrowClasses($carousel, overflowState);
            $carouselList.css('width', setItemWidth($carousel));
            magicLine($carousel, context);
          }, 400)
        );

        // Button click/tap/press.
        $carouselButton.hammer().on('click tap press', function (e) {
          let moveTo = slide($carousel, e.target);
          $carouselList.stop().animate(
            {
              left: moveTo
            },
            {
              complete: function () {
                let overflowState = determineOverflow(
                  carouselList,
                  carouselContainer
                );
                toggleArrowClasses($carousel, overflowState);
              }
            }
          );
        });

        const $tabItem = $('.tab__item', context);

        // Keyboard tab key.
        $tabItem.hammer().on('focus', function (e) {
          let inViewport = isInViewport(e.target);
          let moveTo = $(this).position().left;
          if (!inViewport) {
            $carouselList.stop().animate(
              {
                left: -moveTo
              }
            );
          }
          if (moveTo === 0) {
            toggleArrowClasses($carousel, 'right');
          }
          else if (moveTo >= $carouselContainer.width()) {
            toggleArrowClasses($carousel, 'left');
          }
          else {
            toggleArrowClasses($carousel, 'both');
          }
        });

        // Swipe events.
        $carouselList.hammer().on('swipeleft', function () {
          let moveTo = slide($carousel, 'next');
          $carouselList.stop().animate(
            {
              left: moveTo
            },
            {
              complete: function () {
                let overflowState = determineOverflow(
                  carouselList,
                  carouselContainer
                );
                toggleArrowClasses($carousel, overflowState);
              }
            }
          );
        });
        $carouselList.hammer().on('swiperight', function () {
          let moveTo = slide($carousel, 'prev');
          $carouselList.stop().animate(
            {
              left: moveTo
            },
            {
              complete: function () {
                let overflowState = determineOverflow(
                  carouselList,
                  carouselContainer
                );
                toggleArrowClasses($carousel, overflowState);
              }
            }
          );
        });
      });

      let windowPosition = 0;
      let carouselCSS = {};
      let carouselTop = $carouselRoot.position().top;
      let carouselHeight = $carouselRoot.outerHeight();
      let carouselTogglePosition = carouselTop - carouselHeight;
      // Variables used for scrollspy.
      let lastId = '';
      // All list items
      let menuItems = $('#carouselList', context).find('a');
      // Anchors corresponding to menu items
      let scrollItems = menuItems.map(function () {
        let item = $($(this).attr('href'));
        if (item.length) {
          return item;
        }
      });

      $(window).on(
        'scroll',
        _.debounce(function debounceCarouselPositionSet() {
          windowPosition = $(this).scrollTop();

          if ($(this).width() < 768) {
            // More top margin to account for the topic navigator.
            if (windowPosition >= carouselTogglePosition) {
              carouselCSS = {
                position: 'fixed',
                top: '106px'
              };
            }
            else if (windowPosition < carouselTogglePosition) {
              carouselCSS = {
                position: 'relative',
                top: 'initial'
              };
            }
          }
          else {
            if (windowPosition >= carouselTogglePosition) {
              carouselCSS = {
                position: 'fixed',
                top: '53px'
              };
            }
            else if (windowPosition < carouselTogglePosition) {
              carouselCSS = {
                position: 'relative',
                top: 'initial'
              };
            }
          }

          $carouselRoot.css(carouselCSS);
          // Scrollspy.
          // Get container scroll position
          let fromTop =
            $(this).scrollTop() + carouselHeight + 3 * $nav.outerHeight();
          // Get id of current scroll item
          let current = scrollItems.map(function () {
            if ($(this).offset().top < fromTop) {
              return this;
            }
          });

          if (current.length) {
            // Get the id of the current element
            current = current[current.length - 1];
            let id = $(current).attr('id');
            if (lastId !== id && !isWalkthrough) {
              lastId = id;
              // Set/remove active class
              $(menuItems).attr('aria-selected', 'false');
              $('[href="#' + id + '"]', context).attr('aria-selected', 'true');
            }
          }
        }, 0)
      );
    }
  };
})(jQuery, Drupal, _);
